// extracted by mini-css-extract-plugin
export var helloStyles = "hello-friend-module--helloStyles--IQgDG";
export var helloText = "hello-friend-module--helloText---KN8h";
export var firstChild = "hello-friend-module--firstChild--iwh9z";
export var lastChild = "hello-friend-module--lastChild--ZaUwI";
export var firstLetter = "hello-friend-module--firstLetter--AhwJs";
export var helloAestheticStyles = "hello-friend-module--helloAestheticStyles--3wZJB";
export var helloTextBgStyles = "hello-friend-module--helloTextBgStyles--63pHp";